import { render, staticRenderFns } from "./ReferenceStock.vue?vue&type=template&id=356e74ee&scoped=true&"
import script from "./ReferenceStock.vue?vue&type=script&lang=ts&"
export * from "./ReferenceStock.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceStock.vue?vue&type=style&index=0&id=356e74ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e74ee",
  null
  
)

export default component.exports